import { Autocomplete, AutocompleteProps, Skeleton, TextField, TextFieldProps } from '@mui/material'
import { ProjectWithClientIcon } from './ProjectWithClientIcon'

export type TProjectSelectOption = {
  id: number
  name: string
  client: {
    name: string
    website?: string | null
  } | null
}

type TProjectSelectorInputProps = {
  options?: TProjectSelectOption[]
  value: TProjectSelectOption | null
  textFieldProps?: Omit<TextFieldProps, 'value' | 'onChange'>
} & Omit<AutocompleteProps<TProjectSelectOption, false, false, false>, 'options' | 'value' | 'renderInput'>

export const ProjectSelect = (props: TProjectSelectorInputProps) => {
  const { value, onChange, options, textFieldProps = {} } = props
  if (!options) {
    return <Skeleton variant="text" />
  }
  return (
    <Autocomplete
      disablePortal
      disableClearable
      options={options}
      getOptionLabel={(option) => option.name}
      value={value as any}
      onChange={onChange}
      renderInput={(params) => <TextField {...textFieldProps} {...params} label="Project" />}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props
        return (
          <li {...(optionProps as any)} key={option.id}>
            <ProjectWithClientIcon
              name={option.name}
              client={option.client || undefined}
              sx={{
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                textAlign: 'left',
              }}
            />
          </li>
        )
      }}
      sx={{
        minWidth: 200,
        ...(props.sx || {}),
      }}
    />
  )
}
